import React from 'react';
import { FiInbox } from 'react-icons/fi';

const EmptyState = ({ icon: Icon = FiInbox, title, message }) => {
  return (
    <div className="empty-state">
      <div className="empty-state-icon">
        <Icon />
      </div>
      <h3>{title || 'No data found'}</h3>
      <p>{message || 'There are no items to display.'}</p>
    </div>
  );
};

export default EmptyState;
